define('presentation/settings/billing/billCycleToDate/presentationObjects/billCycleToDatePresentationObject',[],function() {
    return function() {
        var self = this;
        self.currentChargeDate = "";

        self.cycleEndDate = "";
        self.cycleStartDate = "";
        self.nextCycleEndDate = "";
        self.nextCycleStartDate = "";

        self.defaultPaymentMethod = {};
        self.defaultPaymentMethod.cardType = "";
        self.defaultPaymentMethod.lastFourDigits = "";
        self.estimatedCharges = "";
        self.estimatedChargesProcessingDateDisplay = "";

        self.hasPastDueBalance = false;
        self.showPastDueBalance = false;
        self.pastDueBalance = "";
        self.pastDueBalanceCycleEndDate = "";
        self.pastDueBalanceCycleStartDate = "";
        self.pastDueBalanceAutoCloseDate = "";

        self.hasCurrentBalance = false;
        self.showCurrentBalance = false;
        self.currentBalance = "";
        self.currentBalanceCycleEndDate = "";
        self.currentBalanceCycleStartDate = "";
        self.currentBalanceChargeDate = "";
        self.currentBalanceProcessingDateDisplay = "";
        self.currentBalanceToolTipText = "";

        self.phoneNumbers = [];
        self.planAmount = 0;
        self.plan = "";
        self.packageAmount = 0;
        self.package = "";
        self.packageUsage = [];
        self.packageMinutesUsed = 0;
        self.users = [];
        self.scripts = [];
        self.refunds = [];

        self.taxesFeesSurcharges = [];
        self.startingBalance = [];
        self.monthlyRecurringCharges = [];
        self.monthlyRecurringChargesForLiveServices = [];
        self.monthlyRecurringChargesForAutomatedServices = [];

        self.isAccountInOnboarding = false;
        self.isInFreeTrial = false;
        self.isFreeTrialPendingOnboarding = false;
        self.numberOfDaysRemainingInFreeTrial = 0;
        self.displayPlan = false;

        self.hasReceptionistPackage = false;
        self.receptionistPackageMinutesUsed = 0;
        self.receptionistPackageUsage = [];
        self.additionalLiveCallAnsweringMinutes = [];

        self.hasTelephonyPackage = false;
        self.telephonyPackageMinutesUsed = 0;
        self.telephonyPackageUsage = [];
        self.additionalAutomatedMinutes = [];

        self.hasWebChatPackage = false;
        self.webChatsUsed = 0;
        self.webChatPackageUsage = [];
        self.additionalWebChats = [];

        self.hasOutboundCallingPackage = false;
        self.outboundCallingContactsUsed = 0;
        self.outboundCallingPackageUsage = [];
        self.additionalOutreaches = [];

        self.adjustments = [];
        self.currentTaxes = [];

        self.currentTaxesFeesAndSurcharges = "";
        self.currentTaxesFeesAndSurchargesCycleStartDate = "";
        self.currentTaxesFeesAndSurchargesCycleEndDate = "";
        self.currentTaxesFeesAndSurchargesProcessingDateDisplay = "";

        self.currentFederalTaxes = [];
        self.currentStateTaxes = [];
        self.currentLocalTaxes = [];

        self.isLegacyBillFormat = true;
    };
});

